import {Component, OnInit, Inject} from '@angular/core';
import {ErrorStateMatcher, DateAdapter, MAT_DATE_LOCALE} from '@angular/material/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {FormBuilder, FormGroup, FormControl, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import {ConfirmComponent} from '../../../shared/dialogs/confirm/confirm.component';
import {RoleService} from '../../../services/role.service';
import {Role} from '../../../models/role';
import {AuthService} from '../../../services/auth.service';
import {SnackBarIconService} from '../../../shared/snack-bar-icon/snack-bar-icon.service';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-countries-dialog',
  templateUrl: './countries-dialog.component.html',
  styleUrls: [ './countries-dialog.component.scss' ],
  entryComponents: [
    ConfirmComponent
  ],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'pt-BR'}
  ]
})
export class CountriesDialogComponent implements OnInit {

  //public Editor = ClassicEditor;
  public local_title: string;
  public matcher = new FormErrorStateMatcher(); // filter table
  public entityForm: FormGroup;   // store User Form

  public objectImage: any = null;
  public storedImage: any;

  public isEdit: boolean = false;
  public spinner: boolean = false;

  constructor (
    private fb: FormBuilder,
    private _adapter: DateAdapter<any>,
    public matDialogRef: MatDialogRef<CountriesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Role
  ) { }


  ngOnInit () {
    this._adapter.setLocale('pt');
    // check is is insert or update
    if (this.data.id !== "0") {
      this.isEdit = true
    }
    this.entityForm = this.createForm(this.data)
  }

  createForm (data: any) {
    let form: FormGroup = this.fb.group({
      id: new FormControl(data.id),
      file: new FormControl(data.file),
      country: new FormControl(data.country, [ Validators.required ]),
    });

    this.storedImage = data.image;

    return form
  }

  previewImage (event: any) {

    if (event.target.files.length === 0)
      return;

    var mimeType = event.target.files[ 0 ].type;
    if (mimeType.match(/image\/*/) == null) {
      return;
    }

    var reader = new FileReader();
    this.objectImage = event.target.files[ 0 ];
    reader.readAsDataURL(event.target.files[ 0 ]);
    reader.onload = (_event) => {
      this.storedImage = reader.result;
      return event.target.files[ 0 ];
    }
  }


}